import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-token-info',
    templateUrl: './token-info.component.html',
    styleUrls: ['./token-info.component.scss']
})
export class TokenInfoComponent {

    constructor() { }

}
